









export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
